import { SortDirection } from '~/types/Shared'

export enum MissedCallsTableColumn {
  DateTime = 'dateTimeColumn',
  To = 'toColumn',
  From = 'fromColumn',
  FollowUpTime = 'followUpTimeColumn',
  Type = 'typeColumn',
  FollowUpStatus = 'followUpStatusColumn',
  AssignedTo = 'assignedToColumn',
  Action = 'actionColumn',
}

export type MissedCallsTableColumnSorting = {
  column: MissedCallsTableColumn
  direction: SortDirection
}

// Used to build singularly-sorted columns, this will go away if multi-ordering becomes available
export const buildMissedCallsTableColumnSorting = (
  column: MissedCallsTableColumn,
  direction: SortDirection,
) => {
  switch (column) {
    case MissedCallsTableColumn.DateTime:
      return [
        { column, direction },
        { column: MissedCallsTableColumn.Type, direction: undefined },
      ]
    case MissedCallsTableColumn.Type:
      return [
        { column, direction },
        { column: MissedCallsTableColumn.DateTime, direction: undefined },
      ]
  }

  return undefined
}
